import FaqSection from '@/components/sections/home/FaqSection'
import HeroSection from '@/components/sections/home/HeroSection'
import MessagingSection from '@/components/sections/home/MessagingSection'
import PanelsSection from '@/components/sections/home/PanelsSection'
import PathsSection from '@/components/sections/home/PathsSection'
import PricingSection from '@/components/sections/home/PricingSection'
import StatementSection from '@/components/sections/home/StatementSection'
import WhySection from '@/components/sections/home/WhySection'
import { useTitle } from '@/hooks/useTitle'

/** The home page: its sections in order. */
export default function HomePage() {
  useTitle()

  return (
    <>
      <HeroSection />
      <StatementSection />
      <PathsSection />
      <PanelsSection />
      <WhySection />
      <MessagingSection />
      <PricingSection />
      <FaqSection />
    </>
  )
}
